import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { CreateVendorComponent } from './create-vendor/create-vendor.component';
import { ListVendorComponent } from './list-vendor/list-vendor.component';
import { DetailsVendorComponent } from './details-vendor/details-vendor.component';
import { UpdateVendorComponent } from './update-vendor/update-vendor.component';
import { ListFoodMenuComponent } from './list-food-menu/list-food-menu.component';
import { AddFoodMenuComponent } from './add-food-menu/add-food-menu.component';
import { FoodMenuDetailsComponent } from './food-menu-details/food-menu-details.component';
import { UpdateFoodMenuComponent } from './update-food-menu/update-food-menu.component';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { BulkUploadPreviewFoodMenuComponent } from './bulk-upload-preview-food-menu/bulk-upload-preview-food-menu.component';
import { VendorReviewsComponent } from './vendor-reviews/vendor-reviews.component';
import { CreateFoodCourtComponent } from './create-food-court/create-food-court.component';
import { UpdateFoodCourtComponent } from './update-food-court/update-food-court.component';
import { ListFoodCourtComponent } from './list-food-court/list-food-court.component';

const routes: Routes = [
  { path: '', component: CreateVendorComponent },
  { path: 'create-food-vendor', component: CreateVendorComponent },
  { path: 'list-food-vendor/:id', component: ListVendorComponent },
  { path: 'vendor-details/:id', component: DetailsVendorComponent },
  { path: 'update-vendor-details/:id', component: UpdateVendorComponent },
  { path: 'list-food-menu/:id', component: ListFoodMenuComponent },
  { path: 'add-food-menu/:id', component: AddFoodMenuComponent },
  { path: 'menu-details/:id', component: FoodMenuDetailsComponent },
  { path: 'update-food-menu/:id', component: UpdateFoodMenuComponent },
  { path: 'food-menu-bulk-upload/:id', component: BulkUploadComponent },
  { path: 'preview-bulk-upload-food-menu/:id', component: BulkUploadPreviewFoodMenuComponent },
  { path: 'vendor-review-list/:id', component: VendorReviewsComponent },
  { path: 'create-food-court', component: CreateFoodCourtComponent },
  { path: 'update-food-court/:id', component: UpdateFoodCourtComponent },
  { path: 'list-food-court', component: ListFoodCourtComponent },
];


@NgModule({
  declarations: [
    CreateVendorComponent,
    ListVendorComponent,
    DetailsVendorComponent,
    UpdateVendorComponent,
    ListFoodMenuComponent,
    AddFoodMenuComponent,
    FoodMenuDetailsComponent,
    UpdateFoodMenuComponent,
    BulkUploadComponent,
    BulkUploadPreviewFoodMenuComponent,
    VendorReviewsComponent,
    CreateFoodCourtComponent,
    UpdateFoodCourtComponent,
    ListFoodCourtComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    AutocompleteLibModule,
    NgSelectModule,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FoodcourtModule { }
